import {loadStripe} from '@stripe/stripe-js';

var stripe, cardZip;

(async () => {
    stripe = await loadStripe(stripe_pk);

    var donateForm = document.querySelector('#donate-form');
    if (donateForm) {
        initStripeForm();
    }
    var updateForm = document.querySelector('#user-payment-update-form');
    if (updateForm) {
        initStripeForm();
    }
})();

function registerElements(elements, formHolderClass) {

    var formHolder = document.querySelector(formHolderClass);

    var form = formHolder.querySelector('form');
    var error = form.querySelector('.error');
    var errorMessage = error.querySelector('.message');

    function enableInputs() {
        Array.prototype.forEach.call(
            form.querySelectorAll(
                "input[type='text'], input[type='email'], input[type='tel']"
            ),
            function(input) {
                input.removeAttribute('disabled');
            }
        );
    }

    function disableInputs() {
        Array.prototype.forEach.call(
            form.querySelectorAll(
                "input[type='text'], input[type='email'], input[type='tel']"
            ),
            function(input) {
                input.setAttribute('disabled', 'true');
            }
        );
    }

    // cardZip.on('change', function(event) {
    //   formHolder.querySelector('#stripe_cc_zip').value = event.value;
    // });

    // Listen for errors from each Element, and show error messages in the UI.
    var savedErrors = {};
    elements.forEach(function(element, idx) {
        element.on('change', function(event) {
            if (event.error) {
                error.classList.add('visible');
                savedErrors[idx] = event.error.message;
                errorMessage.innerText = event.error.message;
            } else {
                savedErrors[idx] = null;

                // Loop over the saved errors and find the first one, if any.
                var nextError = Object.keys(savedErrors)
                    .sort()
                    .reduce(function(maybeFoundError, key) {
                        return maybeFoundError || savedErrors[key];
                    }, null);

                if (nextError) {
                    // Now that they've fixed the current error, show another one.
                    errorMessage.innerText = nextError;
                } else {
                    // The user fixed the last error; no more errors.
                    error.classList.remove('visible');
                    formHolder.classList.remove('submitting');
                    formHolder.querySelectorAll('input[type="submit"]')[0].removeAttribute('disabled');
                }
            }
        });
    });


    // Listen on the form's 'submit' handler...
    form.addEventListener('submit', function(e) {
        if(formHolder.classList.contains('submitting')) return;
        e.preventDefault();
        if (formHolderClass == '.donate-form-container') {
            if(($('.donation-amounts a.other-amount.selected').length && !$('.amount-field input').val()) || (!$('.donation-amounts a.other-amount.selected').length && !$('#amount-hidden').val())) {
                error.classList.add('visible');
                errorMessage.innerText = 'Please enter an amount to donate.';
                setTimeout(function() { formHolder.querySelectorAll('input[type="submit"]')[0].removeAttribute('disabled') }, 100);
                return;
            }
            else if($('#use_saved_payment').length && $('#use_saved_payment').is(':checked')) {
                const $form = $('#donate-form');
                $('.loading-indicator').css('display', 'inline-block');
                $.ajax({
                    url: $form.attr("action"),
                    type: 'POST',
                    data: $form.serialize(),
                    success: function (result) {
                        eval('result');
                    }
                });
                return;
            } else {
                formHolder.querySelectorAll('input[type="submit"]')[0].setAttribute('disabled', 'true');
                formHolder.classList.add('submitting');

                disableInputs();

                var name = form.querySelector('#donation_name');
                var additionalData = {
                    name: form.querySelector('#donation_name').value
                };
                if($('#create_account').is(':checked') || $('#use_saved_payment').length) {
                    stripe.createToken(elements[0], additionalData).then(function(result) {
                        enableInputs();
                        if (result.token) {
                            formHolder.querySelector('#stripe_token').value = result.token.id;
                            $('.loading-indicator').css('display', 'inline-block');
                            const $form = $('#donate-form');
                            $.ajax({
                                url: $form.attr("action"),
                                type: 'POST',
                                data: $form.serialize(),
                                success: function (result) {
                                    eval(result);
                                }
                            });

                        } else {
                            formHolder.classList.remove('submitting');
                            formHolder.querySelectorAll('input[type="submit"]')[0].removeAttribute('disabled');
                        }
                    });
                } else {
                    stripe.createPaymentMethod({type: 'card', card: elements[0]}, additionalData).then(function(result) {
                        enableInputs();
                        if (result.error) {
                            formHolder.classList.remove('submitting');
                            formHolder.querySelectorAll('input[type="submit"]')[0].removeAttribute('disabled');
                        } else {
                            formHolder.querySelector('#payment_method_id').value = result.paymentMethod.id;
                            const $form = $('#donate-form');
                            $('.loading-indicator').css('display', 'inline-block');
                            $.ajax({
                                url: $form.attr("action"),
                                type: 'POST',
                                data: $form.serialize(),
                                success: function (result) {
                                    eval('result');
                                }
                            });
                        }
                    });
                }
            }
        } else {
            formHolder.querySelectorAll('input[type="submit"]')[0].setAttribute('disabled', 'true');
            formHolder.classList.add('submitting');

            disableInputs();

            stripe.createToken(elements[0]).then(function(result) {
                enableInputs();
                if (result.token) {
                    formHolder.querySelector('#stripe_token').value = result.token.id;
                    $('#user-payment-update-form').submit();
                } else {
                    formHolder.classList.remove('submitting');
                    formHolder.querySelectorAll('input[type="submit"]')[0].removeAttribute('disabled');
                }
            });
        }
    });
}

function initStripeForm () {
    var elements = stripe.elements({
        fonts: [
            {
                cssSrc: 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900',
            },
        ],
        locale: 'en',
    });

    var elementStyles = {
        base: {
            color: 'rgba(0, 0, 0, 0.87)',
            fontWeight: 500,
            fontFamily: "'TTCommons-Medium', sans-serif",
            fontSize: '14px',
            fontSmoothing: 'antialiased',
            lineHeight: '22px',
            '::placeholder': {
                color: 'rgba(0, 0, 0, 0.6)',
            },
        },
        empty: {
            color: 'rgba(0, 0, 0, 0.6)'
        },
        invalid: {
            color: '#E02020',
            ':focus': {
                color: '#E02020',
            },
            '::placeholder': {
                color: '#E02020',
            },
        },
    };

    var elementClasses = {
        focus: 'focus',
        empty: 'empty',
        invalid: 'invalid',
    };

    var cardNumber = elements.create('cardNumber', {
        style: elementStyles,
        classes: elementClasses,
        placeholder: document.querySelector('#card-number').dataset.default,
    });
    cardNumber.mount('#card-number');

    var cardExpiry = elements.create('cardExpiry', {
        style: elementStyles,
        classes: elementClasses,
        placeholder: document.querySelector('#card-expiry').dataset.default,
    });
    cardExpiry.mount('#card-expiry');

    var cardCvc = elements.create('cardCvc', {
        style: elementStyles,
        classes: elementClasses,
        placeholder: document.querySelector('#card-cvc').dataset.default,
    });

    cardCvc.mount('#card-cvc');

    cardZip = elements.create('postalCode', {
        style: elementStyles,
        classes: elementClasses,
        placeholder: document.querySelector('#card-zip').dataset.default,
        value: ('value' in document.querySelector('#card-zip').dataset) ? document.querySelector('#card-zip').dataset.value : '',
    });
    cardZip.mount('#card-zip');
    if ($('.donate-form-container').length) {
        registerElements([cardNumber, cardExpiry, cardCvc, cardZip], '.donate-form-container');
    }
    else {
        registerElements([cardNumber, cardExpiry, cardCvc, cardZip], '.user-payment-update-form-container');
    }
}

window.addEventListener('turbolinks:load', function() {
    if(typeof stripe !== 'undefined') {
        var donateForm = document.querySelector('#donate-form');
        if (donateForm) {
            initStripeForm();
        }
        var updateForm = document.querySelector('#user-payment-update-form');
        if (updateForm) {
            initStripeForm();
        }
    }
});